const HOUR_IN_MS = 3600000;

export const isEventShorterThanOneHour = (
  start: Date | null | undefined,
  end: Date | null | undefined,
): boolean => {
  if (!start || !end) {
    return false;
  }
  return end.getTime() - start.getTime() < HOUR_IN_MS;
};
